export const SP_SERVER = process.env.REACT_APP_SP_SERVER;
export const PORTAL_SERVER = process.env.REACT_APP_PORTAL_SERVER;

export const SERVER_SUFFIX = process.env.REACT_APP_COMMON_SERVER_SUFFIX;
export const PROVIDER_SUFFIX = process.env.REACT_APP_PROVIDER_SERVER_SUFFIX;
